export { SpaDaysVersion as SpaDays } from './SpaDaysVersion';
